import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { FaTag, FaHandshake } from "react-icons/fa";
import { API_BASE_URL } from "../config";


const grassImage = "/images/Grass.jpg";

const MySwapDeals = () => {
  const getStatusText = (deal) => {
  if (deal.category === "mowing") return deal.swap_status;
  if (deal.swap_status === "expired") return "completed";
  return deal.swap_status;
};

  const navigate = useNavigate();
  const user = JSON.parse(localStorage.getItem("user"));

  const [deals, setDeals] = useState([]);
  const [loading, setLoading] = useState(true);

  /* =========================
     LOAD MOWING + CLEANING
  ========================= */
  const fetchDeals = async () => {
    try {
      const token = localStorage.getItem("token");

      const [mowingRes, cleaningRes, poolcareRes] = await Promise.allSettled([
  axios.get(`${API_BASE_URL}/api/swaps/deals/${user.id}`, {
    headers: { Authorization: `Bearer ${token}` },
  }),
  axios.get(`${API_BASE_URL}/api/cleaning/swaps/deals/${user.id}`, {
    headers: { Authorization: `Bearer ${token}` },
  }),
  axios.get(`${API_BASE_URL}/api/poolcare/swaps/deals/${user.id}`, {
    headers: { Authorization: `Bearer ${token}` },
  }),
]);


      const mowingDeals =
        mowingRes.status === "fulfilled" ? mowingRes.value.data.deals || [] : [];

      const cleaningDeals =
        cleaningRes.status === "fulfilled"
          ? cleaningRes.value.data.deals || []
          : [];

      const poolcareDeals =
  poolcareRes.status === "fulfilled"
    ? poolcareRes.value.data.deals || []
    : [];

setDeals([...mowingDeals, ...cleaningDeals, ...poolcareDeals]);

    } catch (err) {
      console.error("❌ Error loading swap deals:", err);
    } finally {
      setLoading(false);
    }
  };

  /* =========================
     STRIPE PAYMENT
  ========================= */
  const handleSwapPayment = async (deal) => {
    try {
      const endpoint =
  deal.category === "cleaning"
    ? `${API_BASE_URL}/api/cleaning/swap-payments/pay`
    : deal.category === "poolcare"
    ? `${API_BASE_URL}/api/poolcare/swaps/swap-payments/pay`
    : `${API_BASE_URL}/api/swaps/swap-payments/create-session`;


      const res = await axios.post(
        endpoint,
        { dealId: deal.id, userId: user.id },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );

      if (res.data?.url) {
        window.location.href = res.data.url;
      } else {
        throw new Error("No Stripe URL returned");
      }
    } catch (err) {
      console.error("❌ Swap payment error:", err.response?.data || err);
      alert("Payment failed to start");
    }
  };

  useEffect(() => {
    fetchDeals();
  }, []);

  return (
    <div style={{ padding: 20, minHeight: "100vh", background: "#f4f7f9" }}>
      <h1 style={{ textAlign: "center", color: "#2e7d32" }}>
        My Swap Deals
      </h1>

      <button
        onClick={() => navigate(-1)}
        style={{
          margin: "20px 0",
          padding: "10px 20px",
          background: "#2e7d32",
          color: "#fff",
          borderRadius: 8,
          border: "none",
          cursor: "pointer",
        }}
      >
        ← Back
      </button>

      {loading ? (
        <p style={{ textAlign: "center" }}>Loading deals…</p>
      ) : deals.length === 0 ? (
        <p style={{ textAlign: "center" }}>No swap deals yet.</p>
      ) : (
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(260px, 1fr))",
            gap: 20,
          }}
        >
          {deals.map((deal) => {
            console.log("DEAL CHECK", {
  dealId: deal.id,
  category: deal.category,
  loggedInUserId: user.id,
  initiatorId: deal.initiatorId,
  receiverId: deal.receiverId,
  paymentA: deal.paymentA,
  paymentB: deal.paymentB,
});

            const swapRef =
              deal.category === "cleaning"
                ? `CSW-${deal.listingId}`
                : `SWP-${deal.id}`;

           const userId = user.id;

// role checks
const isInitiator = user.id === deal.initiatorId;
const isReceiver = user.id === deal.receiverId;

// payment state
const initiatorPaid = deal.paymentA === 1;
const receiverPaid = deal.paymentB === 1;

// can THIS user pay right now?
const canPay =
  deal.category === "poolcare"
    ? deal.swap_status === "payment_required" &&
      !initiatorPaid &&
      !receiverPaid


    : deal.category === "cleaning"
    ? deal.swap_status === "payment_required" &&
      (
        (isInitiator && !initiatorPaid) ||
        (isReceiver && initiatorPaid && !receiverPaid)
      )

    : deal.category === "mowing"
    ? deal.swap_status === "payment_pending"

    : false;







// FINAL pay-button rule
const showPayButton = canPay;






            return (
              <div
                key={`${deal.category}-${deal.id}`}
                style={{
                  background: "#fff",
                  padding: 15,
                  borderRadius: 12,
                  boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    marginBottom: 8,
                  }}
                >
                  <h3>Swap Deal</h3>
                  <span
                    style={{
                      padding: "4px 10px",
                      background: "#e3f2fd",
                      borderRadius: 20,
                      fontSize: 13,
                      textTransform: "capitalize",
                    }}
                  >
                    <FaHandshake /> {deal.category}
                  </span>
                </div>

                <img
                  src={grassImage}
                  alt="swap"
                  style={{
                    width: "100%",
                    height: 160,
                    objectFit: "cover",
                    borderRadius: 10,
                  }}
                />

                <div style={{ margin: "10px 0", fontSize: 14 }}>
                  <FaTag /> <strong>{swapRef}</strong>
                </div>

                <div style={{ fontSize: 14 }}>
                  <strong>From:</strong> {deal.a_fromSuburb}
                  <br />
                  <strong>To:</strong> {deal.b_fromSuburb}
                </div>

                <div style={{ marginTop: 10, fontWeight: "bold" }}>
                 Status: {getStatusText(deal)}

                </div>

                <div style={{ marginTop: 12 }}>
                  {showPayButton ? (
                    <button
                      onClick={() => handleSwapPayment(deal)}
                      style={{
                        width: "100%",
                        padding: 10,
                        background: "#2e7d32",
                        color: "#fff",
                        border: "none",
                        borderRadius: 8,
                      }}
                    >
                      Pay Swap Fee
                    </button>
                  ) : (
<button
  onClick={() =>
    navigate(
      deal.category === "cleaning"
        ? `/cleaning/swap-deal/${deal.id}`
        : deal.category === "poolcare" || deal.category === "pool_care"
        ? `/poolcare/swaps/deal/${deal.id}`
        : `/swap-deal/${deal.id}`
    )
  }
>
  View Deal
</button>

                  )}
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default MySwapDeals;
